<script lang="ts" setup>
import type { ErrorObject } from '@consumer/composables/deprecatedVuelidate'
import type { ComputedRef } from 'vue'

const { error } = defineProps < {
  error?: any
}>()

const slots = useSlots()

const hasError = computed(() => slots.default || errorMessage.value.length > 0)

const isErrorObject = (obj: any): obj is ErrorObject => {
  return obj !== undefined && (obj as ErrorObject).$message !== undefined
}

const errorMessage: ComputedRef<string[]> = computed(() => {
  if (!error) {
    return []
  }

  if (Array.isArray(error)) {
    return error.map(item => String(isErrorObject(item) ? item?.$message : item))
  }
  else {
    return [String(isErrorObject(error) ? error?.$message : error)]
  }
})
</script>

<template>
  <div v-if="hasError" class="mt-2 text-red-base space-y-2 font-medium">
    <slot>
      <div v-for="(message, i) in errorMessage" :key="i" class="text-red-base input-error" data-testid="error-message">
        {{ message }}
      </div>
    </slot>
  </div>
</template>
